import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextColor: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="text-color"><path d="M21.25 7.4375C21.25 8.88725 20.0188 10.25 18.5 10.25C16.9812 10.25 15.75 8.88725 15.75 7.4375C15.75 5.5625 18.5 2.75 18.5 2.75C18.5 2.75 21.25 5.5625 21.25 7.4375Z" stroke="currentColor" strokeWidth="1.5"/><path d="M2.75 20.25L10 4.75L17.25 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6 14.75H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTextColor;
